// Where to land after switching organization: stay on the page the user is
// on, minus anything that belongs to the previous organization -- the query
// string (?locs=, report filters, ids) and record ids in the path.
const ORG_SCOPED_PATHS = [
  [/^\/ai-assistant\/[^/]+/, '/ai-assistant'],
  [/^\/assistant\/[^/]+/, '/assistant'],
  [/^\/etl-config\/schema\/[^/]+/, '/etl-config/schema'],
  [/^\/schema-builder\/[^/]+/, '/etl-config/schema'],
  [/^\/workflow-runs\/[^/]+/, '/dashboard'],
];

export function orgSwitchPath(pathname) {
  const path = pathname || '/dashboard';
  const scoped = ORG_SCOPED_PATHS.find(([re]) => re.test(path));
  return scoped ? scoped[1] : path;
}

// Hard navigation so every page reloads its data for the new organization
// (the org is persisted to localStorage synchronously by setCurrentOrg).
export function reloadForOrgSwitch(pathname) {
  window.location.assign(orgSwitchPath(pathname));
}
